import { combineTransactionSteps, getChangedRanges } from '@tiptap/core';
import type { NodeType } from '@tiptap/pm/model';
import { Plugin, PluginKey } from '@tiptap/pm/state';

import { getWrappedField, isBodyBlockParent } from '../nodes/formField/formFieldHelpers';
import { markSystemTr } from './shared';

// Removes a card that lost its field; a field without an answer keeps its card.
const getEmptyFormFieldPlugin = (cardType: NodeType): Plugin =>
  new Plugin({
    key: new PluginKey('emptyFormField'),
    appendTransaction: (transactions, oldState, newState) => {
      if (!transactions.some((tr) => tr.docChanged)) return null;

      const emptyCards = new Map<number, number>();
      getChangedRanges(combineTransactionSteps(oldState.doc, [...transactions])).forEach(({ newRange }) => {
        newState.doc.nodesBetween(newRange.from, newRange.to, (node, pos) => {
          if (node.type !== cardType) return isBodyBlockParent(node);
          if (!getWrappedField(node, pos)) emptyCards.set(pos, pos + node.nodeSize);
          return false;
        });
      });
      if (!emptyCards.size) return null;

      const { tr } = newState;
      [...emptyCards].sort(([a], [b]) => b - a).forEach(([from, to]) => tr.delete(from, to));
      // In history, so the undo that brings the field back brings its card with it.
      return markSystemTr(tr, { keepInHistory: true });
    },
  });

export default getEmptyFormFieldPlugin;
